import { render, staticRenderFns } from "./CreateOrganisation.vue?vue&type=template&id=b8552dbe&scoped=true"
import script from "./CreateOrganisation.vue?vue&type=script&lang=js"
export * from "./CreateOrganisation.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganisation.vue?vue&type=style&index=0&id=b8552dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8552dbe",
  null
  
)

export default component.exports